/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from "react";
import mapboxgl from "mapbox-gl";
import { convert as convertMbxApi } from "@mapbox/yolp-mapbox-static-maps";
import { Menu } from "./Menu";

const token = "pk.eyJ1IjoidGFrdXRvc3V6dWtpbWFwYm94IiwiYSI6ImNrMjJlMXplcTE4a2czY3F3MWkxZHN4cWkifQ.CRcFM34KAOiPKIbscodOqA";
const accountId = "takutosuzukimapbox";
const style = "ckbr7hngq60l11inw41dhcla0";

const generateYJUrl = (height, width) => {
  return `https://map.yahooapis.jp/map/V1/static?appid=dj00aiZpPXBsS1dycEZQczV4TyZzPWNvbnN1bWVyc2VjcmV0Jng9NTc-&lat=35.658619279712&lon=139.74553000746&z=15&width=${width}&height=${height}&pin1=35.658619279712,139.74553000746,Tower&pin5=35.669619279712,139.74953000746,Tower,blue&l=0,0,0,1,2,35.681564010675,139.76721006431,34.701974475101,135.49513431327&e=0,255,0,0,5,0,255,0,127,35.669619279712,139.74953000746,1000&p=0,0,255,0,3,0,0,255,60,35.667099078055365,139.73058972764818,35.66578290519938,139.72930226732103,35.6644579940522,139.7310617964348,35.66597466683339,139.73281059671243`;
};

mapboxgl.accessToken = token;

const Application = () => {
  const [yjApiUrl, setYjApiUrl] = useState("");
  const [mbxApiUrl, setMbxApiUrl] = useState("");
  const [mbxAccountId, setMbxAccountId] = useState(accountId);
  const [mbxStyleId, setMbxStyleId] = useState(style);
  const [mbxToken, setMbxToken] = useState(token);

  const onConvert = url => {
    const opts = {
      accountId: mbxAccountId,
      mapboxToken: mbxToken,
      style: mbxStyleId
    };
    const mbxurl = convertMbxApi(url || yjApiUrl, opts);
    setMbxApiUrl(mbxurl);
  };

  const updateImgSize = () => {
    const newYJUrl = generateYJUrl(window.innerHeight, window.innerWidth / 2);
    setYjApiUrl(newYJUrl);

  };

  useEffect(() => {
    if (!yjApiUrl || !mbxToken || !mbxAccountId || !mbxStyleId) {
      return;
    }
    onConvert(yjApiUrl);
  }, [yjApiUrl, mbxToken, mbxAccountId, mbxStyleId]);

  useEffect(() => {
    updateImgSize();
    window.addEventListener("resize", updateImgSize);
    return () => {
      window.removeEventListener("resize", updateImgSize);
    };
  }, []);

  return (
    <>
      <Menu
        mbxAccountId={mbxAccountId}
        mbxApiUrl={mbxApiUrl}
        mbxStyleId={mbxStyleId}
        mbxToken={mbxToken}
        setMbxAccountId={setMbxAccountId}
        setMbxToken={setMbxToken}
        setMbxStyleId={setMbxStyleId}
        setYjApiUrl={setYjApiUrl}
        yjApiUrl={yjApiUrl} />
      <div className="grid">
        <div className="grid viewport-full">
          <div className='col col--6'>
            <div className='align-center'>
              <span style={labelStyle}>YOLP Static Images</span>
              <img style={imgStyle} src={yjApiUrl} />
            </div>
          </div>
          <div className='col col--6'>
            <div className='align-center'>
              <span style={labelStyle}>Mapbox Static Images</span>
              <img style={imgStyle} src={mbxApiUrl} />
            </div>
          </div>
        </div>
      </div>
    </>);
};

const labelStyle = {
  background: "black",
  opacity: 0.8,
  color: "white",
  padding: "10px 20px 10px 20px"
};

const imgStyle = {
  marginTop: "-20px"
};

export default Application;
